import type { ReplicaDatabase } from '../db/replica-database';
import type { HttpClient } from '../http/http-client';
import type { PullResponse } from '../types/pull-response';
import { storeRecords } from './store-records';

const PAGE = 1000;
const MAX_PAGES = 1000;

/**
 * Pull every record changed since the cursor. A different server_id, or a cursor ahead of the
 * server (a restored backup), means its data is the truth: drop the copy, keep the outbox.
 */
export async function pullChanges(db: ReplicaDatabase, http: HttpClient): Promise<void> {
  let since = (await db.getMeta<number>('cursor')) ?? 0;
  const knownServer = await db.getMeta<string>('server_id');
  for (let page = 0; page < MAX_PAGES; page++) {
    const body = await http.json<PullResponse>(`/sync/pull?since=${since}&limit=${PAGE}`);
    const replaced = page === 0 && knownServer !== undefined && body.server_id !== knownServer;
    if (replaced || body.cursor < since) {
      await db.transaction('rw', db.records, db.meta, async () => {
        await db.records.clear();
        await db.setMeta('cursor', 0);
        await db.setMeta('server_id', body.server_id);
      });
      since = 0;
      continue;
    }
    await db.transaction('rw', db.records, db.meta, async () => {
      await storeRecords(db, body.records);
      await db.setMeta('cursor', body.cursor);
      await db.setMeta('server_id', body.server_id);
    });
    since = body.cursor;
    if (!body.has_more) return;
  }
}
